import React, { useRef } from 'react';
import CTAButton from '../../shared/CTAButton';
import { useFadeUp } from '../../shared/useFadeUp';
import { useHeroVideoShrink } from '../../shared/useHeroVideoShrink';
import { heroBackground } from '../../../assets/v2';
import './heroSection.css';

const HERO_VIDEO_URL = `${process.env.PUBLIC_URL}/videos/morph-demo-opt.mp4`;
const HERO_VIDEO_WEBM_URL = `${process.env.PUBLIC_URL}/videos/morph-demo-opt.webm`;
const HERO_POSTER_URL = `${process.env.PUBLIC_URL}/videos/morph-poster.webp`;

const HeroSection: React.FC = () => {
  const eyebrow = useFadeUp<HTMLParagraphElement>();
  const title = useFadeUp<HTMLHeadingElement>();
  const copy = useFadeUp<HTMLParagraphElement>();
  const ctas = useFadeUp<HTMLDivElement>();
  const visual = useRef<HTMLDivElement>(null);

  useHeroVideoShrink(visual);

  const scrollToDownload = () => {
    document.getElementById('download')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      className="v2-hero"
      id="home"
      data-page-bg="#0a1628"
      style={
        { '--hero-bg-url': `url(${heroBackground})` } as React.CSSProperties
      }
    >
      <div className="v2-hero__container">
        <div className="v2-hero__text">
          <p
            ref={eyebrow.ref}
            className={`v2-hero__eyebrow fade-up ${eyebrow.isVisible ? 'is-visible' : ''}`}
          >
            AI Home Inspection Software
          </p>
          <h1
            ref={title.ref}
            className={`v2-hero__title fade-up ${title.isVisible ? 'is-visible' : ''}`}
          >
            Leave the Property
            <br />
            <em>with the Report Ready.</em>
          </h1>
          <p
            ref={copy.ref}
            className={`v2-hero__copy fade-up ${copy.isVisible ? 'is-visible' : ''}`}
          >
            Morph turns your photos and voice notes into a structured home
            inspection report — on-site, in minutes.
          </p>
          <div
            ref={ctas.ref}
            className={`v2-hero__ctas fade-up ${ctas.isVisible ? 'is-visible' : ''}`}
          >
            <CTAButton variant="gold" size="lg" onClick={scrollToDownload}>
              Download &amp; Try
            </CTAButton>
          </div>
        </div>
        <div className="v2-hero__visual" ref={visual}>
          <div className="v2-hero__phone">
            <video
              poster={HERO_POSTER_URL}
              autoPlay
              loop
              muted
              playsInline
              preload="metadata"
            >
              <source src={HERO_VIDEO_WEBM_URL} type="video/webm" />
              <source src={HERO_VIDEO_URL} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
